import { defineComponent as _defineComponent } from 'vue';
import { cn } from 'Components/primitives/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Kbd',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
